import $ from 'jquery';

export default function makeSilktideIgnoreCookiebotDialog() {
    $(window).on('CookiebotOnDialogDisplay', function() {
        $('#CybotCookiebotDialog').attr('data-silktide', 'ignore');
    });
}
